function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: o-HelveticaNeue, Arial, sans-serif;\n  font-weight: 400;\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin: 0;\n  padding: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  font-family: o-HelveticaNeue, Arial, sans-serif;\n  font-weight: 700;\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin: 0;\n  padding: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  margin: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ErrorSevere from '../Icons/ErrorSevere';
import Info from '../Icons/Info';
import WarningImportant from '../Icons/WarningImportant';
import TickCircle from '../Icons/TickCircle';
import Button from '../Buttons/Button';
import ArrowLink from '../Links/ArrowLink';
import { colors, alert, text } from '../../styles/variables';
import { px2rem, padding, margin } from '../Utils/helpers';
var Container = styled('div')(_templateObject(), function (_ref) {
  var mini = _ref.mini;
  return padding(!mini ? alert.standard.container : alert.mini.container);
});
var StyledArrowLink = styled(ArrowLink)(_templateObject2());
var Content = styled('div')(_templateObject3(), function (_ref2) {
  var mini = _ref2.mini;

  if (!mini) {
    return margin({
      marginLeft: alert.standard.container.paddingLeft + alert.standard.icon.size
    });
  }

  return margin({
    marginLeft: alert.mini.container.paddingLeft + alert.mini.icon.size
  });
});
var TitleContainer = styled('div')(_templateObject4());
var IconContainer = styled('div')(_templateObject5(), function (_ref3) {
  var mini = _ref3.mini;
  return px2rem(!mini ? alert.standard.icon.size : alert.mini.icon.size);
}, function (_ref4) {
  var mini = _ref4.mini;
  return px2rem(!mini ? alert.standard.icon.size : alert.mini.icon.size);
});
var Title = styled('p')(_templateObject6(), colors.text, function (_ref5) {
  var mini = _ref5.mini;
  return px2rem(!mini ? text.standard.large.fontSize : text.standard.medium.fontSize);
}, function (_ref6) {
  var mini = _ref6.mini;
  return px2rem(!mini ? text.standard.large.lineHeight : text.standard.medium.lineHeight);
}, function (_ref7) {
  var mini = _ref7.mini,
      hasButton = _ref7.hasButton;

  if (!mini) {
    return padding(alert.standard.title);
  }

  if (!hasButton) {
    return padding(alert.mini.title.withoutLink);
  }

  return padding(alert.mini.title.withLink);
});
var AlertText = styled('p')(_templateObject7(), colors.text, function (_ref8) {
  var mini = _ref8.mini;
  return px2rem(!mini ? text.standard.large.fontSize : text.standard.medium.fontSize);
}, function (_ref9) {
  var mini = _ref9.mini;
  return px2rem(!mini ? text.standard.large.lineHeight : text.standard.medium.lineHeight);
}, function (_ref10) {
  var mini = _ref10.mini;
  return padding(!mini ? alert.standard.text : alert.mini.text);
});
var ButtonContainer = styled('div')(_templateObject8(), function (_ref11) {
  var mini = _ref11.mini;
  return padding(!mini ? alert.standard.button : alert.mini.button);
}); // https://app.zeplin.io/project/5c3323cb6124c7af1c4ce96e/screen/5c333cdb46bce344084ae352

function Alert(props) {
  var className = props.className,
      mini = props.mini,
      variant = props.variant,
      title = props.title,
      content = props.content,
      button = props.button,
      onClickButton = props.onClickButton,
      contentDisplayed = props.contentDisplayed;
  var backgroundColor;
  var icon;
  var iconColor;
  var arrowBackground;

  switch (variant) {
    case 'error':
      backgroundColor = colors.dimmedError;
      icon = ErrorSevere;
      iconColor = 'error';
      arrowBackground = 'dimmedError';
      break;

    case 'info':
      backgroundColor = colors.dimmedInfo;
      icon = Info;
      iconColor = 'info';
      arrowBackground = 'dimmedInfo';
      break;

    case 'alert':
      backgroundColor = colors.dimmedAlert;
      icon = WarningImportant;
      iconColor = 'alert';
      arrowBackground = 'dimmedAlert';
      break;

    case 'success':
    default:
      backgroundColor = colors.dimmedSuccess;
      icon = TickCircle;
      iconColor = 'success';
      arrowBackground = 'dimmedSuccess';
  }

  return React.createElement(Container, {
    style: {
      backgroundColor: backgroundColor
    },
    mini: mini,
    className: className
  }, React.createElement(TitleContainer, null, React.createElement(IconContainer, {
    mini: mini
  }, React.createElement(icon, {
    size: !mini ? alert.standard.icon.size : alert.mini.icon.size,
    color: iconColor
  })), React.createElement(Title, {
    mini: mini,
    hasButton: button !== undefined
  }, title)), (content || button) && React.createElement(Content, {
    mini: mini
  }, button !== undefined && mini && React.createElement(ButtonContainer, {
    mini: true
  }, React.createElement(StyledArrowLink, {
    href: "#",
    mini: true,
    variant: content === undefined && 'next' || !contentDisplayed && 'down' || 'up',
    background: arrowBackground,
    onClick: onClickButton
  }, button)), content && (contentDisplayed || !mini) && content.map(function (contentText, index) {
    return (// eslint-disable-next-line react/no-array-index-key
      React.createElement(AlertText, {
        key: index,
        mini: mini
      }, contentText)
    );
  }), button !== undefined && !mini && React.createElement(ButtonContainer, null, React.createElement(Button, {
    variant: "secondary",
    onClick: onClickButton
  }, button))));
}

Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  variant: PropTypes.oneOf(['error', 'info', 'alert', 'success']),
  title: PropTypes.string.isRequired,
  content: PropTypes.arrayOf(PropTypes.node),
  button: PropTypes.string,
  onClickButton: PropTypes.func,
  mini: PropTypes.bool,
  contentDisplayed: PropTypes.bool
} : {};
Alert.defaultProps = {
  className: undefined,
  variant: 'success',
  content: undefined,
  button: undefined,
  onClickButton: undefined,
  mini: false,
  contentDisplayed: false
};
export default Alert;